import styled, { css } from "styled-components";
import { ArweaveImage } from "../../components/ArweaveImage";
import { Flex } from "../../components/Grid";
import { DropEntry } from "../../dropTypes";
import { IMAGE_SIZES } from "../../lib/constants";
import { smallScreen } from "../../lib/mediaQuery";
import { ThumbnailStatus } from "./thumbnailStatus";

interface Props {
  imageUrl: string;
  isPending: boolean;
  drop?: DropEntry;
  isMint?: boolean;
}

export const ThumbnailImage = ({ imageUrl, isPending, drop }: Props) => {
  return (
    <DropImageContainer>
      <ArweaveImage
        fill
        sizes={IMAGE_SIZES}
        alt="Box set covert art"
        src={imageUrl}
        style={{
          objectFit: "cover",
        }}
      />
      {drop && <ThumbnailStatus drop={drop} isPending={isPending} />}
    </DropImageContainer>
  );
};

const borderRadius = css`
  border-radius: 3px;
`;

export const ThumbnailContainer = styled(Flex)`
  position: relative;
  box-sizing: border-box;
  flex-wrap: nowrap;
  cursor: pointer;
  &[data-is-disabled="true"] {
    cursor: auto;
  }
  &[data-is-transfering="true"][data-is-selected="false"] {
    opacity: 0.35;
  }
  &[data-is-transfering="true"]:hover {
    opacity: 1;
  }
  &[data-is-transfering="true"]:focus {
    opacity: 1;
  }
  &[data-is-selected="true"] {
    opacity: 1;
  }
`;

const DropImageContainer = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  overflow: hidden;
  padding-bottom: 100%;
  ${smallScreen(
    css`
      width: 100%;
      height: 100%;
    `
  )};
  ${borderRadius}
  transition: filter var(--transition-speed-normal) var(--easing-standard);
  ${ThumbnailContainer}:hover & {
    @supports not (-moz-appearance: none) {
      filter: drop-shadow(0px 0px 15px rgba(0, 232, 255, 0.6));
    }
  }
  [data-is-disabled="true"]:hover & {
    filter: none;
  }
`;
